
import axios from "axios"
const service = axios.create()

service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    // if (response.data.code == 10000) {
    //     if (!toLogining) {
    //         Message.error('请重新登录！');
    //         location.replace(`/login`)
    //     }
    //     toLogining = true
    //     setTimeout(() => {
    //         toLogining = false
    //     }, 5000);
    //     return
    // }
    return response;
}, function (error) {
    // 对响应错误做点什么
    console.log('error', error);
    if(error.response.data == 'Unauthorized.') {
        location.replace('#/login')
    }
    return Promise.reject(error);
});

export const request = (url, method, options = {}) => {
    let headers = {}
    let token = localStorage.getItem("mykc-token")
    if (token && url !== 'api/auth/login') {
        headers.Authorization = `Bearer ${token}`
    }
    return service({
        url,
        method,
        headers,
        ...options,
    })
}